module.exports = __webpack_public_path__ + "static/media/480.63dc95f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-flower-bouquet/light/480.png
// module id = 2060
// module chunks = 2